import React from "react";
class TextAnswer extends React.Component {
  clicked() {
    this.props.onClick();
  }

  render() {
    return (
      <div className='answer'>
        <button className='btn btn-primary text-answer-btn' type='button' onClick={() => this.clicked()} >
          {this.props.isShowingAnswer ? 'Hide Answer' : 'Reveal Answer'}
        </button>
      </div>
    );
  }
}
export default TextAnswer
